module.exports = __webpack_public_path__ + "static/img/monitor02.789c2265.png";